'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _core = require('../core');

var _geometry = require('../geometry');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IcoSphere = function (_Model) {
  _inherits(IcoSphere, _Model);

  function IcoSphere() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, IcoSphere);

    return _possibleConstructorReturn(this, (IcoSphere.__proto__ || Object.getPrototypeOf(IcoSphere)).call(this, Object.assign({}, opts, { geometry: new _geometry.IcoSphereGeometry(opts) })));
  }

  return IcoSphere;
}(_core.Model);

exports.default = IcoSphere;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RlbHMvaWNvLXNwaGVyZS5qcyJdLCJuYW1lcyI6WyJJY29TcGhlcmUiLCJvcHRzIiwiT2JqZWN0IiwiYXNzaWduIiwiZ2VvbWV0cnkiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFDQTs7Ozs7Ozs7SUFFcUJBLFM7OztBQUNuQix1QkFBdUI7QUFBQSxRQUFYQyxJQUFXLHVFQUFKLEVBQUk7O0FBQUE7O0FBQUEsaUhBQ2ZDLE9BQU9DLE1BQVAsQ0FBYyxFQUFkLEVBQWtCRixJQUFsQixFQUF3QixFQUFDRyxVQUFVLGdDQUFzQkgsSUFBdEIsQ0FBWCxFQUF4QixDQURlO0FBRXRCOzs7OztrQkFIa0JELFMiLCJmaWxlIjoiaWNvLXNwaGVyZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7TW9kZWx9IGZyb20gJy4uL2NvcmUnO1xuaW1wb3J0IHtJY29TcGhlcmVHZW9tZXRyeX0gZnJvbSAnLi4vZ2VvbWV0cnknO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBJY29TcGhlcmUgZXh0ZW5kcyBNb2RlbCB7XG4gIGNvbnN0cnVjdG9yKG9wdHMgPSB7fSkge1xuICAgIHN1cGVyKE9iamVjdC5hc3NpZ24oe30sIG9wdHMsIHtnZW9tZXRyeTogbmV3IEljb1NwaGVyZUdlb21ldHJ5KG9wdHMpfSkpO1xuICB9XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/models/ico-sphere.js
// module id = 1058
// module chunks = 0